"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StarIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.522.365a.495.495 0 01.956 0l1.66 5.345h5.358c.488 0 .69.66.294.96l-4.332 3.295 1.657 5.338c.151.487-.378.895-.773.594L8 12.595l-4.342 3.302c-.395.3-.924-.107-.773-.594l1.657-5.338L.21 6.67c-.396-.3-.194-.96.294-.96h5.359L7.522.365z"
  })))
});
StarIcon.displayName = 'StarIcon';
var _default = exports.default = StarIcon;